"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
var ControlName;
(function (ControlName) {
    ControlName["EnableIsolate"] = "enableIsolate";
    ControlName["Hidden"] = "hidden";
    ControlName["Faded"] = "faded";
    ControlName["HidingOthers"] = "hidingOthers";
    ControlName["FadingOthers"] = "fadingOthers";
})(ControlName || (ControlName = {}));
function ControlsMenu() {
    const { isMobile } = (0, device_1.usePlatform)();
    const controlsState = (0, hooks_1.useInfoBoxControlsState)();
    const [{ currentTab, isExpanded }] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { isActive } = (0, hooks_1.useMultiSelectState)();
    const onClick = (button) => () => {
        switch (button) {
            case ControlName.EnableIsolate:
                bridge === null || bridge === void 0 ? void 0 : bridge.isolateAction({
                    animated: true,
                    activateExplodeIsolate: false,
                });
                requestAnimationFrame(() => {
                    navigate(isActive ? '/mode/multiselect-focus' : '/mode/isolate');
                });
                break;
            case ControlName.Hidden:
                bridge === null || bridge === void 0 ? void 0 : bridge.hideAction();
                break;
            case ControlName.Faded:
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeAction();
                break;
            case ControlName.HidingOthers:
                bridge === null || bridge === void 0 ? void 0 : bridge.hideOthersAction();
                break;
            case ControlName.FadingOthers:
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeOthersAction();
                break;
        }
    };
    const Container = isMobile ? ContainerMobile : ContainerDesktop;
    const byButtonOrder = (a, b) => {
        const buttonOrder = [
            ControlName.EnableIsolate,
            ControlName.Hidden,
            ControlName.Faded,
            ControlName.HidingOthers,
            ControlName.FadingOthers,
        ];
        return buttonOrder.indexOf(a) - buttonOrder.indexOf(b);
    };
    const shouldShow = currentTab === bridge_schema_1.InfoBoxTabType.None || !isExpanded;
    const controls = Object.keys(controlsState).sort(byButtonOrder);
    return ((0, jsx_runtime_1.jsxs)(Container, { "$shouldShow": shouldShow, "data-e2e": 'ControlsMenu_Container', children: [controls.map(key => {
                const selected = controlsState[key] === hooks_1.ControlState.Selected;
                const disabled = controlsState[key] === hooks_1.ControlState.Disabled;
                return ((0, jsx_runtime_1.jsx)(atoms_1.ControlsMenuButton, { selected: selected, disabled: disabled, onClick: disabled ? noop_1.default : onClick(key), "data-e2e": 'ControlsMenu_ControlsMenuButton', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.menu[key]) }, key));
            }), !isMobile && (0, jsx_runtime_1.jsx)(atoms_1.MultiSelectionButton, { "data-e2e": 'ControlsMenu_MultiSelectionButton' })] }));
}
exports.ControlsMenu = ControlsMenu;
const ContainerDesktop = styled_components_1.default.div `
  flex-basis: 76px;
  box-sizing: border-box;

  width: 76px;
  min-width: 76px;
  height: 198px;
  padding: 4px 0;

  border-left: 1px solid ${({ theme }) => theme.thinLine};
`;
const ContainerMobile = styled_components_1.default.div `
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 44px;
  margin-bottom: 4px;

  opacity: ${({ $shouldShow }) => ($shouldShow ? 1 : 0)};

  transition: opacity 0.2s ease-in-out;

  pointer-events: ${({ $shouldShow }) => ($shouldShow ? 'auto' : 'none')};
`;
